



















import { sleep } from "@root/lib/utils";
import {
  Component,
  Prop,
  Vue,
  Mixins,
  Watch,
  InjectReactive
} from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
const productCreate = namespace("productCreate");
@Component({
  components: {}
})
export default class channelSkuMediaDialog extends Vue {
  @productCreate.Action uploadChannelImage;
  @InjectReactive("curChannel") curChannel;
  @Prop({ default: () => [] }) dataValue; // 需要回显的值
  @Prop({ default: () => "" }) node; // 编辑节点的
  @Prop({ default: false }) readonly; // 是否只读
  mediaTempData: any = [];
  private acceptType =
    "image/webp,image/bmp,image/gif,image/jpeg,image/jpg,image/png,video/*";
  max = 8;
  @Watch("dataValue", { immediate: true })
  watchDataValue(val) {
    console.log(val);

    this.mediaTempData = val || [];
  }
  // op图片上传成功之后
  async uploadChannel(fileUrl) {
    let url = await this.uploadChannelImage({
      input: {
        image: fileUrl,
        shopCode: this.curChannel.value,
        channelCode: this.curChannel.channelCode
      }
    });
    return url;
  }
  async onsuccess([url]) {
    this.$emit("changeSkuMedia", url);
  }
  onRemove() {
    this.$emit("changeSkuMedia", "");
  }
}
